import React, { useEffect, useState } from "react";
import {
  CogIcon,
  UserIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import {
  DetailsApi,
  createPartnersCall,
  updateLastStep,
} from "../../services/redux/ApiActions";
import Stepper from "../Common/Stepper";
import showNotification from "../../services/redux/NotifcationService";
import { useDispatch, useSelector } from "react-redux";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import LogoDiv from "../Common/LogoDiv";
import logo from "../../img/BBPS_Horizontal.png";

export default function StepThreePartner() {
  const customerData = useSelector((state) => state.customerData.customerData);
  const details = useSelector((state) => state.details.details);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forms, setForms] = useState([]);
  const containsSociety = details?.result.businessType
    .toLowerCase()
    .includes("society");
  const [showLogo, setShowLogo] = useState(false);

  // Initialize forms state with details.partners when it's available
  useEffect(() => {
    if (details?.result && details?.result.partners.length > 0) {
      setForms(
        details?.result.partners.map((partner) => ({
          name: partner.partnerName || "",
          pan: partner.partnerPAN || "",
          isNameFilled: partner.partnerName ? true : false,
          isPanFilled: partner.partnerPAN ? true : false,
        }))
      );
    } else {
      // If details.partners is not available, initialize with an empty form
      setForms([
        {
          name: "",
          pan: "",
          isNameFilled: false,
          isPanFilled: false,
        },
      ]);
    }
  }, [details]);

  const addNewForm = () => {
    setForms([
      ...forms,
      {
        name: "",
        pan: "",
        isNameFilled: false,
        isPanFilled: false,
      },
    ]);
  };

  const removeForm = (index) => {
    const updatedForms = [...forms];
    updatedForms.splice(index, 1);
    setForms(updatedForms);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedForms = [...forms];
    updatedForms[index][name] = value;
    updatedForms[index][
      `is${name.charAt(0).toUpperCase()}${name.slice(1)}Filled`
    ] = value.trim() !== "";
    setForms(updatedForms);
  };

  const isFormFilled = (form) => {
    return form.isNameFilled && form.isPanFilled;
  };

  const handleSubmit = async () => {
    // Check if all forms are filled sequentially before proceeding
    const isValid = forms.every((form, index) => {
      if (index === forms.length - 1) {
        return isFormFilled(form);
      }
      return isFormFilled(form) && isFormFilled(forms[index + 1]);
    });

    if (isValid) {
      const payload = forms.map((form) => ({
        customerId: customerData?.custId,
        partnerName: form.name,
        partnerPAN: form.pan,
        createdBy: details?.result.createdBy,
        createdIp: "",
        createdUserAgent: "",
      }));
      // console.log(payload);
      try {
        const data = await dispatch(
          createPartnersCall(
            payload,
            customerData?.token_chr,
            customerData?.custId
          )
        );
        if (data.statusCode === 200) {
          try {
            const data = await dispatch(
              updateLastStep("", customerData?.token_chr, customerData?.custId)
            );
            if (data) {
              showNotification("Success", "success");
              navigate("/Customer/Step4");
              getDetails();
            }
          } catch (error) {
            showNotification(error, "error");
          }
        } else {
          showNotification("Something went wrong", "error");
        }
      } catch (error) {
        showNotification(error, "error");
      }
    } else {
      showNotification("Please fill in all the fields", "warning");
    }
  };

  const getDetails = async () => {
    // console.log(userAgent)
    const Payload = {
      id: customerData.custId,
    };
    // console.log(Payload)
    const data = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer")
    );
    dispatch(setDetailsData(data));
    if (data?.result?.programId === 34 || data?.result?.programId === 35) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };
  useEffect(() => {
    getDetails();
  }, []);

  return (
    <>
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          LIST OF {containsSociety ? "DIRECTORS" : "PARTNERS"}
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo &&
                        {
                          /* <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width={"100px"} height={"100px"} />
                        </div> */
                        }}
                    </div>
                  </div>
                  <div className="py-2 text-center">
                    <h1 className="text-sm text-gray-600">
                      Please provide the required details of your organisation
                    </h1>
                  </div>
                  <div className=" border-none border-collapse rounded-md">
                    <div className="text-right">
                      <button
                        className="vtpRm-action-button"
                        onClick={addNewForm}
                      >
                        <div className="flex">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4.5v15m7.5-7.5h-15"
                            />
                          </svg>
                          <label className="hover:cursor-pointer">
                            Add New
                          </label>
                        </div>
                      </button>
                    </div>

                    {forms.map((form, index) => (
                      <div key={index} className="bg-gray-300 p-6 mt-2 mb-2">
                        <div className="grid grid-cols-12 gap-4">
                          <div className="col-span-5 md:col-span-5 lg:col-span-5">
                            <label
                              htmlFor={`name-${index}`}
                              className="block text-md font-medium leading-6 text-gray-900"
                            >
                              Name <span className="text-red-600">*</span>
                            </label>
                            <CustomerInput
                              id={`name-${index}`}
                              name="name"
                              value={form.name}
                              onChange={(e) => handleChange(index, e)}
                              placeHolder="Enter Name"
                              inputStyles={{ padding: "12px" }}
                            />
                          </div>
                          <div className="col-span-5 md:col-span-5 lg:col-span-5">
                            <label
                              htmlFor={`pan-${index}`}
                              className="block text-md font-medium leading-6 text-gray-900"
                            >
                              PAN <span className="text-red-600">*</span>
                            </label>
                            <CustomerInput
                              id={`pan-${index}`}
                              name="pan"
                              value={form.pan}
                              onChange={(e) => handleChange(index, e)}
                              placeHolder="ENTER PAN"
                              inputStyles={{ padding: "12px" }}
                            />
                          </div>
                          <div className="col-span-2 md:col-span-2 lg:col-span-2">
                            {index !== 0 && (
                              <div className="mt-7 flex justify-start">
                                <div
                                  className="hover:cursor-pointer"
                                  onClick={() => removeForm(index)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="red"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="white"
                                    className="w-12 h-12"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                      <div className="relative text-center">
                        <button
                          onClick={handleSubmit}
                          className="vtpRm-action-button"
                        >
                          {details?.result.lastCompletedStep > 3
                            ? "Proceed"
                            : "Create and proceed"}
                        </button>
                        {details?.result.lastCompletedStep > 3 ? (
                          <>
                            <span
                              className="skip-btn hover:cursor-pointer py-4 px-4"
                              onClick={() => navigate("/Customer/Step4")}
                            >
                              Skip this step
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
      </body>
    </>
  );
}
